import React from "react";
import { useDocumentTitle } from "../../hooks/use-document-title";
import "./Error404Page.scss";

const Error404Page: React.FC = () => {
  useDocumentTitle("404 - Page Not Found");

  return (
    <div className="error-404-page-container">
      <h1>404 - Page Not Found</h1>
      <p>Sorry, the page you are looking for does not exist.</p>
    </div>
  );
};

export default Error404Page;
